import { create } from 'zustand';
import { currentTimeFormat } from 'src/utils/dateSet';
import { familyInfo } from 'src/static/sample/stepA';
import { initial } from 'lodash';

interface initDataState {
  param: any;
  bindParam: any;
  result: any;
  payload: any;
  bind: (result: { data: any }) => void;
  bindPayload: (payload: { data: any }) => void;
}

export const initPreworkPayload = {
  acct_year: '', // 연말정산 년도
  co_cd: '', // 회사코드
  co_id: '', // 사번
  name: '', // 이름
  prev_co_name: '', // 회사명
  prev_co_num: '', // 사업자등록번호
  work_type: '', // 근무지구분

  start_date: '', // 근무시작일
  end_date: '', // 근무종료일
  red_start_date: '', // 감면기간 시작
  red_end_date: '', // 감면기간 종료

  // ===== 과세 급여 =====
  tsal_base: 0, // 급여
  tsal_bonus: 0, // 상여
  tsal_rbonus: 0, // 인정상여
  tsal_stkopt: 0, // 주식매수선택권행사이익
  tsal_esop_withdrawal: 0, // 우리사주조합인출금
  tsal_excess_exec_retire: 0, // 임원퇴직소득금액한도초과
  tsal_excess_invent_reward: 0, // 직무발명보상금(한도초과분)

  // ===== 세금 =====
  tax_income: 0, // 소득세
  tax_local: 0, // 지방소득세
  tax_rural: 0, // 농어촌특별세

  // ===== 연금 =====
  ppen_national: 0, // 국민연금보험료
  ppen_gov: 0, // 공무원연금
  ppen_military: 0, // 군인연금
  ppen_private_school: 0, // 사립학교교직원연금
  ppen_postal: 0, // 별정우체국연금

  // ===== 보험 =====
  pins_health: 0, // 건강보험료(노인장기요양보험료 포함)
  pins_emp: 0, // 고용보험료

  // ===== 비과세 소득 =====
  nsal_g01: 0, // 비과세학자금
  nsal_h05: 0, // 경호·승선수당
  nsal_h06: 0, // 유아·초중등
  nsal_h07: 0, // 고등교육법
  nsal_h08: 0, // 특별법
  nsal_h09: 0, // 연구기관 등
  nsal_h10: 0, // 기업부설연구소
  nsal_h11: 0, // 취재수당
  nsal_h12: 0, // 벽지수당
  nsal_h13: 0, // 재해관련급여
  nsal_h14: 0, // 보육교사 근무환경개선비
  nsal_h15: 0, // 사립유치원수석교사·교사 인건비
  nsal_h16: 0, // 정부공공기관 지방이전기관종사자 이주수당
  nsal_h17: 0, // 종교활동비
  nsal_i01: 0, // 외국정부등근무자
  nsal_k01: 0, // 외국주둔군인등
  nsal_m01: 0, // 국외근로 100만원
  nsal_m03: 0, // 국외근로
  nsal_m04: 0, // 국외근로 500만원
  nsal_o01: 0, // 야간근로수당
  nsal_p01: 0, // 비과세 식사대
  nsal_q02: 0, // 보육수당
  nsal_q03: 0, // 출산지원금(1회)
  nsal_q04: 0, // 출산지원금(2회)
  nsal_r10: 0, // 근로장학금
  nsal_r11: 0, // 직무발명보상금
  nsal_s01: 0, // 주식매수선택권
  nsal_u01: 0, // 벤처기업 주식매수선택권
  nsal_y02: 0, // 우리사주조합인출금 50%
  nsal_y03: 0, // 우리사주조합인출금 75%
  nsal_y04: 0, // 우리사주조합인출금 100%
  nsal_y22: 0, // 전공의수련 보조 수당

  // ===== 세액 감면 =====
  tred_t00: 0, // 소득세법
  tred_t01: 0, // 외국인기술자 소득세감면(50%)
  tred_t02: 0, // 외국인기술자 소득세감면(70%)
  tred_t12: 0, // 중소기업 취업자 소득세 감면(70%)
  tred_t13: 0, // 중소기업 취업자 소득세 감면(90%)
  tred_t20: 0, // 조세조약상교직자감면
  tred_t30: 0, // 성과공유 중소기업 경영성과급(50%)
  tred_t40: 0, // 중소기업 청년근로자·핵심인력 성과보상기금 감면(50%)
  tred_t41: 0, // 중견기업 청년근로자·핵심인력 성과보상기금 감면(30%)
  tred_t42: 0, // 중소기업 청년근로자·핵심인력 성과보상기금 감면(90%)
  tred_t43: 0, // 중견기업 청년근로자·핵심인력 성과보상기금 감면(50%)
  tred_t50: 0, // 내국인 우수인력 국내복귀 소득세 감면(50%)
};

export const requiredPreworkSet = [
  { id: 'prev_co_name', label: '회사명' },
  { id: 'prev_co_num', label: '사업자등록번호' },
  { id: 'tsal_base', label: '급여' },
];
export const checkRequired = (id: string) => {
  const requiredSet: any = requiredPreworkSet || [];
  let check = '';
  requiredSet.forEach((item: any) => {
    if (item.id === id) check = 'Y';
  });
  return check;
};

/**
  종전근무지
**/
export const preworkDataStore = create<initDataState>(set => ({
  param: { initialSeq: 0 },
  bindParam: (bind: any) =>
    set(state => ({
      ...state,
      param: { ...state.param, ...bind },
    })),
  result: [],
  bind: (data: any) =>
    set(state => ({
      ...state,
      result: { ...state.result, ...data },
    })),
  payload: initPreworkPayload,
  bindPayload: (data: any) =>
    set(state => ({
      ...state,
      payload: { ...state.payload, ...data },
    })),
}));
